import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 768px;
    background: #4B708A;
    height: 100%;
`;


export const ContainerHome= styled.div`

    height: 100vh;
    display: flex;
    flex-direction: column;
    background: ${props => props.background};
    width: 100%;
    color: white;
    text-align: center;
    justify-items: center;
    justify-content: center;
    align-items: center;
`;

export const ContainerBody= styled.div`

    height: 100vh;
    display: flex;
    flex-direction: column;
    background: ${props => props.background};
    width: 100%;
    color: white;
    justify-content: space-between;
    text-align: center;
    justify-items: center;
    align-items: center;
`;

export const Wrapper = styled.div`
    height: 80vh;
    display: flex;
    flex-direction: column;
    width: 90%;
    justify-items: center;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;    
`;

export const WrapperContato = styled.div`
    height: 80vh;
    display: flex;
    flex-direction: column;
    width: 90%;
    justify-items: center;
    align-items: center;
    margin-top: 30px;    
`;

export const CollImg = styled.div`
  width: 100%;
  height: 40%;
  display: flex;
  justify-content: center;
  align-items: center; 
  div{
  padding: 10px;
  margin-top: 10px;
  }
`;


export const CollCard = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  color: black;
  justify-content: space-between; 
  justify-items: baseline;
  align-content: baseline;
  align-items: center;
  margin-bottom: 15px;
  margin-top: -10px;
`;